(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Hotjar, Config, $) {
    'use strict';

    Hotjar.callTrigger = function (label) {
        console.log('hotjar-trigger: ' + label);
        hj('trigger', label);
    }

    Hotjar.startRecording = function (tag) {
        hj('trigger', Config.HotjarRecordingTrigger);
        hj('tagRecording', tag);
    }

})(LN.Hotjar, LN.Config, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/hotjar.js